import FormAssetUploadField from "../assetUploadField";
import { AssetInputMode, AssetUploadType } from "../../core/assetUpload/types";
import React from "react";
import { FormMultiFileUploadFieldType } from "./type";
import DefaultFileAssetUIRenderer from "../../core/assetUpload/defaultFileAssetUiRenderer";
import { DEFAULT_MULTI_FILE_ASSET_CONFIG } from "shared/form/core/assetUpload/constants";

function FormMultiFileUploadField({
  assetConfig = DEFAULT_MULTI_FILE_ASSET_CONFIG,
  assetUploadType = AssetUploadType.FILE,
  ...props
}: FormMultiFileUploadFieldType) {
  return (
    <FormAssetUploadField
      customRenderer={customRendererProps => {
        return (
          <DefaultFileAssetUIRenderer
            {...customRendererProps}
            max={props.max}
            min={props.min}
            disableImagePreview={props.disableImagePreview}
          />
        );
      }}
      assetUploadType={assetUploadType}
      registrationId={props.registrationId}
      registrationParticipantId={props.registrationParticipantId}
      label={props.label}
      name={props.name}
      fullWidth={props.fullWidth}
      required={props.required}
      additionalLabel={props.additionalLabel}
      disabled={props.disabled}
      assetInputMode={AssetInputMode.MULTI}
      validate={props.validate}
      infoLabel={props.infoLabel}
      assetConfig={assetConfig}
      assetType={props.assetType}
      className={props.className}
    />
  );
}

export default FormMultiFileUploadField;
